export default __webpack_public_path__ + "static/hochzeitsfotos-berlin-brandenburg-potsdam-claudia_nuernberger-02-79a7af8944a85633b73ea0561ec7cf1c.jpg";